<template>
  <div id="class-detail-container"
       ref="pride_tab_fixed">
    <div class="container pc-web">
      <!-- modal -->
      <div class="left"
           ref="leftContainer">
        <div class="title-wrap">
          <div class="title">
            <div class="icon flex-center">
              <p>{{cardInfo.subject}}</p>
            </div>
            <div class="detail">{{cardInfo.title}}</div>
          </div>
          <div v-if="cardInfo.subTitle"
               class="web_subTitle"
               style="background:white;color:rgba(51,51,51,0.5);padding-left: 32px;">{{cardInfo.subTitle}}</div>
          <TeacherSwiper :sum="4"
                         v-if="teacherArray"
                         :teacherListSwiper="teacherArray"
                         :width="containerWidth+'px'"></TeacherSwiper>
        </div>
        <div class="content"
             ref="selected_bar_title">
          <div>
            <SubclassInfo :classState="classState"
                          ref="subclass"
                          :subclassDetail=classDetail
                          :classData="classData"
                          :cardInfo="cardInfo"
                          :offlineListbtnState="offlineListbtnState"
                          :selectedBarTitleFixed="selectedBarTitleFixed"
                          :tipWidth="tipWidth"
                          :belong="belong"></SubclassInfo>
          </div>
        </div>
      </div>
      <!-- 右边 -->
      <div class="right pride_tab"
           :class="titleFixed == true ? 'isFixed' :''"
           ref="right">
        <div class="share">
          <span class="syme"
                v-if="!isAllPlayBackClass">{{syPeopleSum}}</span>
          <img src="../../assets/img/icon/share.svg"
               alt
               @click="shareCourse" />
        </div>
        <div class="right-container">
          <div class="info-container">
            <div class="row date">
              <div class="icon flex-center">
                <img src="@/assets/img/icon/calendar.png"
                     alt />
              </div>
              <div class="info flex-center">{{cardInfo.date}}</div>
              <el-badge>
                <el-button class="status" plain size="mini" type="primary">{{cardInfo.classProcess}}</el-button>
              </el-badge>
            </div>
            <div class="row time"
                 v-if="classState !== 'live'">
              <div class="icon flex-center">
                <img src="@/assets/img/icon/time.png"
                     alt />
              </div>
              <div class="info flex-center">{{cardInfo.time}}</div>
            </div>
            <div class="row place"
                 v-if="classState !== 'live'">
              <div class="icon flex-center">
                <img src="@/assets/img/icon/place.png"
                     alt />
              </div>
              <div class="info flex-center">{{cardInfo.position}}</div>
            </div>
          </div>
          <!-- 正常课 -->
          <div v-if="orginClass">
            <div class="pc-price"
                 v-if="!offlineBought">
              <div class="price"
                   v-if="classState === 'offline'">¥{{cardInfo.realPrice}}</div>
              <div style="display:flex;align-items: baseline;margin-top: 50px;color: #ffa000;"
                   v-if="classState === 'live'&&cardInfo.price===0">免费课程</div>
              <div style="display:flex;align-items: baseline;"
                   v-else>
                <div class="price"
                     v-if="classState === 'live'"
                     style="margin-right: 6px;">¥{{cardInfo.realPrice}}</div>
                <div v-if="classState === 'live'&&cardInfo.virtualPrice!==-1"
                     style="text-decoration: line-through;font-size:16px;color:rgba(51,51,51,0.4);">¥{{cardInfo.virtualPrice}}</div>
              </div>
              <span v-show="isShowMaterial">含{{materialPrice}}元教材费</span>
            </div>
            <div class="button-area"
                 :style="newBtnText==='立即预约'&&!isShowBtn?'display:none;':''">
              <!-- <el-button class="btn-share" @click="shareCourse">分享课程</el-button> -->
              <el-button type="primary"
                         class="buy"
                         @click="joinIn()"
                         :disabled="btnClickState"
                         v-if="btnsum===1">{{newBtnText}}</el-button>
              <el-button plain
                         :type="shoppingCarState?'info':'primary'"
                         class="btn-with-union"
                         :disabled="shoppingCarState"
                         @click="addToCar"
                         v-if="btnsum===1&&!btnClickState&&isShowCar===1&&isNoAdmin===2&&newBtnText!=='分享完成拼团'">
                {{shoppingCarText}}
              </el-button>
              <!-- <el-button plain
                         type="primary"
                         class="btn-with-union"
                         @click="lianbao"
                         v-if="isLianbao&&btnsum===1&&!btnClickState"
                         :disabled="shoppingCarState"
                         :style="shoppingCarState?'background: #C0C4CC;color:white;':''">
                {{lianBaotext}}
                <span class="tag"
                      v-if="classData.activity_info">
                  <i class="left-gradient"
                     v-show="lianBaoDiscount"></i>{{lianBaoDiscount}}
                  <i class="right-gradient"
                     v-show="lianBaoDiscount"></i>
                </span>
              </el-button> -->
            </div>
          </div>
          <!-- 团购课 -->
          <div v-if="!orginClass">
            <div class="group-info"
                 v-if="!offlineBought">
              <div>
                <span>{{cardInfo.groupNum}}人成团</span>
              </div>
              <div>拼团</div>
              <div>¥</div>
              <div>{{cardInfo.groupPrice}}</div>
              <div>
                <p v-show="isShowMaterial">含{{materialPrice}}元教材费</p>
                <p :style="isShowMaterial?'':'margin-top:12px;'">原价¥{{cardInfo.price}}</p>
              </div>
            </div>
            <div class="button-area"
                 v-if="btnsum===2">
              <el-button type="danger"
                         class="btn-group"
                         @click="joinIn()"
                         style="background:#FFEFEE;color:#EF4D3C;">原价报名</el-button>
              <el-button type="danger"
                         class="groupbuy"
                         @click="joinIn('group')">发起拼团</el-button>
            </div>
            <div class="button-area"
                 v-if="btnsum===1">
              <el-button type="danger"
                         class="buy"
                         @click="shareJoin()"
                         :disabled="btnClickState">{{newBtnText}}</el-button>
            </div>
            <div class="group-time"
                 v-if="cardInfo.groupEndTime">
              <Countdown :endTime="cardInfo.groupEndTime"
                         :callback="groupEndCallback"
                         endText="活动已经结束"
                         :textState="1"
                         :type="1"></Countdown>
            </div>
          </div>
        </div>
        <!-- 更多参团 -->
        <div v-if="moreGroupState && groupTop1 != -1">
          <div class="right-bottom">
            <div class="right-bottomleft"
                 v-if="groupTop1 != -1">
              <div class="buyimg"
                   v-if="groupTop1.member_info[0]">
                <img :src="groupTop1.member_info[0].avatar" />
              </div>
              <div class="buyname"
                   v-if="groupTop1.member_info[0]">{{groupTop1.member_info[0].name}}</div>
            </div>
            <div class="right-bottomright">
              <div class="right-groupinfo"
                   v-if="groupTop1 != -1">
                <div v-if="groupTop1.member_info">
                  还差
                  <span>{{groupTop1.group_num - groupTop1.member_info.length}}</span>人拼团成功
                </div>
                <div>
                  <Countdown v-if="groupTop1.create_at"
                             :callback="groupEndCallback"
                             :endTime="groupTop1.duration*60*60 + groupTop1.create_at"
                             endText="活动已经结束"
                             :textState="0"
                             :type="2"></Countdown>
                </div>
              </div>
              <div>
                <el-button @click="joinIn('join', groupTop1.group_id), getJoinPrice(groupTop1.price)"
                           type="danger">去参团</el-button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="right-bottommore"
               @click="morebuy"
               v-if="groupTop1 != -1 && moreGroupState">
            查看更多拼团&nbsp;
            <i class="fa fa-chevron-right"></i>
          </div>
        </div>
        <div class="lianbao-entrance" v-if="lianbaoList.length>0">
          <div class="lianbao-top"></div>
          <div class="lianbao-list" v-for="(item, index) in lianbaoList" :key="index" @click="toUnion(item.union_id)">
            <div class="lianbao-content">
              <div class="lb-title">{{unionType[item.union_template.union_type || 99]}}</div>
              <div class="lb-discount" v-if="item.discount_type === 2">
                <span v-if="item.ladder_pricings.length>1">最高直减</span>
                <span v-else-if="item.ladder_pricings.length===1">直减</span>
                <span>{{(item.discount_val/100)}}</span>
                元 <i class="fa fa-chevron-right"
style="transform: translateY(-1px) translateX(-2px);"></i>
              </div>
              <div class="lb-discount" v-if="item.discount_type === 1">
                <span v-if="item.ladder_pricings.length>1">最高立享</span>
                <span v-else-if="item.ladder_pricings.length===1">立享</span>
                <span>{{(item.discount_val/10)}}</span>
                折 <i class="fa fa-chevron-right"
style="transform: translateY(-1px) translateX(-2px);"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机页面 -->
    <div class="phone"
         v-if="isMobile">
      <div class="class-detail-header">
        <div class="back-arrow">
          <!-- <img src="@/assets/img/icon/icon_back.png" alt @click="back" /> -->
          <i class="el-icon-arrow-left"
             @click="back"></i>
        </div>
        <div class="class-detail-title">{{cardInfo.title}}</div>
      </div>
      <div class="class-detail-card">
        <div class="syme"
             v-if="!isAllPlayBackClass">{{syPeopleSum}}</div>
        <el-badge class="iphone_process">
          <el-button class="status" plain size="mini" type="primary">{{cardInfo.classProcess}}</el-button>
        </el-badge>
        <ClassCard :date="cardInfo.date"
                   :classProcess="cardInfo.classProcess"
                   :time="cardInfo.time"
                   :position="cardInfo.position"
                   :teacher="cardInfo.teacher"
                   :price="cardInfo.price"
                   :ComponentsStyle="0"
                   :realPrice="cardInfo.realPrice"
                   :groupState="phonegroupState"
                   :groupPrice="cardInfo.groupPrice"
                   :classLabel="classState"
                   hideTitle:true
                   :isShowMaterial="isShowMaterial"
                   :materialPrice="materialPrice"
                   :virtual_price="cardInfo.virtualPhonePrice"
                   :isAllPlayBackClass="isAllPlayBackClass" />
      </div>
      <div class="class-lianbao-entrance" v-if="lianbaoList.length>0">
      <div class="class-lianbao-content" v-for="(item, index) in lianbaoList" :key="index" @click="toUnion(item.union_id)">
        <div class="class-lianbao-title"><span :style="index===0?'':'visibility:hidden;'">联报</span><span class="class-lianbao-name">{{unionType[item.union_template.union_type || 99]}}</span></div>
        <div class="class-discount" v-if="item.discount_type === 2">最高直减<span>{{item.discount_val/100}}</span>元 <i class="fa fa-chevron-right"
style="transform: translateY(-1px) translateX(-2px);"></i></div>
        <div class="class-discount" v-else-if="item.discount_type === 1">立享<span>{{item.discount_val/10}}</span>折 <i class="fa fa-chevron-right"
style="transform: translateY(-1px) translateX(-2px);"></i></div>
      </div>
      </div>
      <div style="width:100%;">
        <div class="phone_teacherlist">授课老师</div>
        <TeacherSwiper :sum="2"
                       :teacherListSwiper="teacherArray"></TeacherSwiper>
      </div>
      <div class="class-detail-info">
        <div class="info-contaienr">
          <div v-if="moreGroupState && groupTop1 != -1">
            <div class="sginfo">
              <div class="sgtitle">
                <div>正在拼团</div>
                <div @click="changeMore">
                  查看更多拼团
                  <i class="fa fa-chevron-right"></i>
                </div>
              </div>
              <div v-if="groupTop1">
                <div class="right-bottom">
                  <div class="right-bottomleft"
                       v-if="groupTop1 != -1">
                    <div class="buyimg"
                         v-if="groupTop1.member_info[0]">
                      <img :src="groupTop1.member_info[0].avatar" />
                    </div>
                    <div class="buyname"
                         v-if="groupTop1.member_info[0]">{{groupTop1.member_info[0].name}}</div>
                  </div>
                  <div class="right-bottomright">
                    <div class="right-groupinfo">
                      <div v-if="groupTop1.member_info">
                        还差
                        <span>{{groupTop1.group_num - groupTop1.member_info.length}}</span>人拼团成功
                      </div>
                      <div>
                        <Countdown v-if="groupTop1.create_at"
                                   :callback="groupEndCallback"
                                   :endTime="groupTop1.duration*60*60 + groupTop1.create_at"
                                   endText="活动已经结束"
                                   :textState="0"
                                   :type="2"></Countdown>
                      </div>
                    </div>
                    <div>
                      <el-button type="danger"
                                 @click="joinIn('join', groupTop1.group_id), getJoinPrice(groupTop1.price)">去参团</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SubclassInfo :classState="classState"
                          :subclassDetail=classDetail
                          :classData="classData"
                          :cardInfo="cardInfo"
                          :offlineListbtnState="offlineListbtnState"
                          :selectedBarTitleFixed="selectedBarTitleFixed"
                          :tipWidth="tipWidth"
                          :belong="belong"></SubclassInfo>
          </div>
        </div>
        <!-- 正常课 -->
        <div class="button-area2"
             style="position: fixed;bottom:0;background:white;align-items:center;"
             v-if="orginClass"
             :style="newBtnText==='立即预约'&&!isShowBtn?'display:none;':''">
          <el-button class="join-now flex-center"
                     type="primary"
                     @click="joinIn('phone')"
                     :disabled="btnClickState"
                     v-if="btnsum===1">{{newBtnText}}</el-button>
          <el-button plain
                     :type="shoppingCarState?'info':'primary'"
                     class="btn-with-union"
                     @click="addToCar"
                     v-if="btnsum===1&&!btnClickState&&cardInfo.price>0&&isNoAdmin===2&&newBtnText!=='分享完成拼团'"
                     :disabled="shoppingCarState"
                     style="border-radius: 20px;">
            {{shoppingCarText}}
            <!-- 加入购课单 -->
          </el-button>
          <!-- <el-button plain
                     round
                     type="primary"
                     class="btn-with-union"
                     @click="lianbao"
                     v-if="isLianbao&&btnsum===1&&!btnClickState"
                     :disabled="shoppingCarState"
                     :style="shoppingCarState?'background: #C0C4CC;color:white;':''">
            {{lianBaotext}}
            <span class="tag"
                  v-if="classData.activity_info">
              <i class="left-gradient"
                 v-show="lianBaoDiscount"></i>{{lianBaoDiscount}}
              <i class="right-gradient"
                 v-show="lianBaoDiscount"></i>
            </span>
          </el-button> -->
        </div>
        <!-- 团购课 -->
        <div v-if="!orginClass">
          <div class="button-area2"
               style="position: fixed;bottom:0;background:white;">
            <div style="display:flex;width:91.4%;justify-content: space-between;">
              <div>
                <div style="margin-top:13px;margin-bottom:10px;font-size:12px;color:rgba(51,51,51,0.6);">距离团购结束还剩</div>
                <div style="font-size:12px;color:rgba(51,51,51,1);">
                  <Countdown v-if="cardInfo.groupEndTime"
                             :callback="groupEndCallback"
                             :endTime="cardInfo.groupEndTime"
                             endText="活动已经结束"
                             :textState="0"
                             :type="1"></Countdown>
                </div>
              </div>
              <div style="margin-top:8px;"
                   v-if="btnsum===2">
                <el-button type="danger"
                           @click="joinIn('phone')"
                           :style="signUpBthDisabled?'border:1px solid #dedede;color:#dedede;':''">原价报名</el-button>
                <el-button type="danger"
                           @click="joinIn('phone','group')"
                           :disabled="signUpBthDisabled">{{cardInfo.groupNum}}人成团</el-button>
              </div>
            </div>
          </div>
          <!-- 参团一个按钮 -->
          <div class="button-area"
               style="position: fixed;bottom:0;"
               v-if="btnsum===1">
            <el-button style="width:152px;"
                       class="join-now flex-center"
                       type="danger"
                       @click="shareJoin()"
                       :disabled="btnClickState">{{newBtnText}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="phoneMoreSG"
         v-if="phoneMoreSG && !isFull && groupTop && groupTop.length">
      <div class="phoneMoreSG-list">
        <div style="width:91.4%;margin:auto">
          <div class="phoneMoreSG-title">
            <div>正在拼团</div>
            <i @click="changeMore"
               class="fa fa-icon_home_clear"
               style="opacity: 0.3;"></i>
          </div>
          <div>
            <ul>
              <li v-if="groupTop">
                <ul class="spell-group"
                    v-for="(item, index) in groupTop"
                    :key="index">
                  <li v-if="groupTop1.member_info">
                    <img :src="item.member_info[0].avatar"
                         alt />
                  </li>
                  <li v-if="groupTop1.member_info">{{item.member_info[0].name}}</li>
                  <li v-if="item.member_info">还差{{item.group_num - item.member_info.length}}人拼团成功</li>
                  <li>
                    <Countdown v-if="item.create_at"
                               :callback="collageCallback"
                               :item="item"
                               :endTime="item.duration*60*60 + item.create_at"
                               endText="活动已经结束"
                               :textState="0"
                               :type="2"></Countdown>
                  </li>
                  <li @click="joinIn('join', item.group_id), getJoinPrice(item.price)">去参团</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <JoinUpNow ref="JoinUpNow"
               :classInfo="cardInfo"></JoinUpNow>
    <ShareTip ref="ShareTip" />
    <MoreGroupBuy v-if="moresgstate"
                  :moreGroup="groupTop"
                  @moreJoin="joinIn"></MoreGroupBuy>
    <!-- <Lianbao v-if="showLianbao"
             :goods-id-props="classData.goods_id"
             mode-type="live"
             :courses-in-cart-props="[]"
             :closeCB="closeLianBaoModal"
             @lianbao-jiesuan="lianbaoJiesuan"
             @addcart-callback="addCart"></Lianbao> -->
    <PlayBackList ref="playback"
                  :classList="playBackList"></PlayBackList>
  </div>
</template>
<script>
import $ from 'jquery'
import qs from 'qs'
import wx from 'weixin-js-sdk'
import api from '@/api'
import moment from 'moment'
import axios from 'axios'
import utils from '@/utils/utils'
import JoinUpNow from '@/components/JoinUpNow'
import Countdown from '@/components/CountDown'
import ClassCard from '@/components/ClassCard'
// import Lianbao from '@/components/LianBaoModal'
import PlayBackList from '@/components/PlayBackList'
// import Qa from '@/components/Qa'
import TeacherSwiper from '@/components/TeacherSwiper'
import MoreGroupBuy from '@/views/classDetail/MoreGroupBuy'
import ShareTip from '@/components/ShareTip'
import { mapState, mapActions } from 'vuex'
import live from './live'
import { LOGIN_TYPE, UnionType } from '@/utils/constants'
import filters from '@/utils/filters'
import SubclassInfo from '@/views/classDetail/SubclassInfo'

export default {
  data: function () {
    return {
      unionType: UnionType,
      isAllPlayBackClass: false,
      offlineBought: false, // 面授课是否全部购买
      activity_type: 0, // 提交订单 默认0为正常 1为团购
      rightInfoState: false, // 右边是否为团购信息
      PayState: false, // 付款状态
      groupSuccess: true, // 订单支付后团是否拼成功
      orderId: 0,
      moreGroupState: false, // 更多参团列表显示状态
      groupOrderLoad: false, // 课程团购时间结束  但团还在 控制右边显示团购样式
      shareText: '已报名此课程',
      moreWarnState: false, // 更多课程情况 如名额已满
      moreWarnText: '名额已满',
      moreWTopState: true, // 更多情况控制参团列表的显示
      nowPayState: false, // 课程转变类型 以前的数据判断
      phoneMoreSG: false, // 移动端更多拼团
      signUpBthDisabled: false,
      selectedBarTitleFixed: false,
      signUpBthText: '立报此课程',
      selectedType: 'classDetail',
      titleFixed: false,
      classDetail: [],
      cardInfo: {},
      classPlan: [],
      groupTop: [],
      groupTop1: -1,
      groupLength: 0,
      user_group: {},
      syPeopleSum: '',
      isFull: false,
      signRight: [],
      signRight2: [],
      orginClass: true,
      btnsum: 0,
      newBtnText: '立报此课程',
      btnClickState: false,
      infoPayNo: 0,
      shareJoinText: '',
      isLoadding: false,
      phonegroupState: 2,
      i: 0, // 控制右边吸顶
      classState: 'live', // 面授的课状态offline 直播状态为live
      teacherArray: [],
      offlineListbtnState: false,
      shoppingCarState: false,
      shoppingCarText: '加入购课单',
      isShowCar: 1,
      question: [
        {
          title: 'Q：你们的特色是什么？',
          answer: 'A: 全部师资均来源于985等名校。'
        },
        {
          title: 'Q：如何联系质心灵动量线下客服？',
          answer:
            'A: 1.可以关注微信公众号“质心灵动量”，对话框输入“客服”，扫码添加客服。2.拨打前台电话0755-83502250。'
        },
        {
          title: 'Q：是否可以试听？',
          answer:
            'A: 第一节为免费试听课，试听后，如不满意不收取任何费用（需提前联系客服预约）。'
        },
        {
          title: 'Q：校区地址在哪里？',
          answer: 'A: 深圳市福田区园岭街道园东社区红岭中路红岭商业楼302。'
        },
        {
          title: 'Q：购课后如何退款？',
          answer: 'A: 联系客服，可随时退款（特价班除外），2周内可实现退款。已上完的课程及新购买的回放课程不支持退费，课程配套教材费用不支持退费。'
        }
      ],
      belong: '',
      isShowBtn: true, // 讲座课程结束隐藏按钮或者选课中心的0元课
      containerWidth: 0,
      tipWidth: 0,
      showLianbao: false,
      offlineLianbaoState: false, // 面授课联报
      buyOfflineSubclass: [],
      target: '',
      isNoAdmin: 2,
      // 面授课回放
      playBackList: [],
      isShowMaterial: false,
      materialPrice: 0,
      toConfirmParams: {
        type: '',
        activityType: '',
        classId: ''
      },
      lianbaoList: []
    }
  },
  mixins: [live],
  components: {
    ClassCard,
    JoinUpNow,
    MoreGroupBuy,
    Countdown,
    ShareTip,
    TeacherSwiper,
    // Qa,
    // Lianbao,
    SubclassInfo,
    PlayBackList
  },
  mounted () {
    this.titleFixed = false
    utils.pageShare(wx, this.getShareParams())
    this.handleScroll()
    const refleftContainer = this.$refs.leftContainer
    const reftipContainer = this.$refs.subclass.$refs.classTip
    this.$nextTick(() => {
      this.containerWidth = refleftContainer.clientWidth
      this.tipWidth = reftipContainer.clientWidth
    })
  },
  created () {
    this.init()
    this.classState = this.$route.params.classType
    this.isNoAdmin = this.userInfo.role === 1 ? 1 : 2
  },
  destroyed () {
    $(window).off('scroll', this.scrollFunc)
  },
  methods: {
    ...mapActions(['getUserInfo', 'addCar']),
    toUnion (unid) {
      const params = {
        union_id: unid,
        goods_id: this.cardInfo.goods_id
      }
      api.canGoodsBuyUnion(params).then(res => {
        if (res.data.code === 1) {
          this.$router.push({
            name: 'Union',
            params: { unionId: unid, classId: this.$route.params.classId }
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    getUnionByUnionIdInfo (ids) {
      const params = {
        union_ids: (ids).join(',')
      }
      api.getUnionByUnionIdInfo(params).then(res => {
        if (res.data.code === 1) {
          const item = res.data.data
          this.lianbaoList = item
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    addCart ({ goodsIds, goodsType }) {
      this.addCar({
        goodsIds,
        goodsType,
        callback: () => {
          this.shoppingCarState = true
          this.shoppingCarText = '已加入购课单'
          utils.ballAnimation(this.target)
        }
      })
    },
    // 加入购物车
    addToCar (e) {
      if (!this.isLogin) {
        this.goLogin()
        return
      }
      const $element = $(e.currentTarget)
      this.addCar({
        goodsIds: [Number(this.cardInfo.goods_id)],
        goodsType: this.$route.params.classType === 'live' ? 2 : 5,
        callback: () => {
          this.shoppingCarState = true
          this.shoppingCarText = '已加入购课单'
          utils.ballAnimation($element)
        }
      })
    },
    init () {
      if (this.$route.params.classType === 'live') {
        this.liveinit()
      } else if (this.$route.params.classType === 'offline') {
        setTimeout(item => {
          if (this.isLogin) {
            this.getMyAllCourse()
          } else {
            this.initOffline()
          }
        }, 500)
      }
    },
    selectType (e) {
      window.scroll(0, 0)
      this.selectedType = e
    },
    scrollFunc () {
      const offsetTop =
        this.$refs.pride_tab_fixed &&
        this.$refs.pride_tab_fixed.getBoundingClientRect().top
      const selectedBarTitleFixedtop =
        this.$refs.selected_bar_title &&
        this.$refs.selected_bar_title.getBoundingClientRect().top
      this.titleFixed = offsetTop < 0
      this.selectedBarTitleFixed = selectedBarTitleFixedtop < 0
      //
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      const scroll = scrollTop - this.i
      this.i = scrollTop
      if (scroll < 0) {
        // 添加你想要的事件
        $('.isFixed').css({ top: -offsetTop + 79 })
      } else {
        // 添加你想要的事件
        $('.isFixed').css({ top: -offsetTop + 49 })
      }
      //
      // $('.isFixed').css({ top: -offsetTop + 49 })
      // $('.selectedBarTitleFixed').css({ top: -selectedBarTitleFixedtop })
      // console.log('e', scrollTop)
      if (scrollTop >= 207) {
        this.selectedBarTitleFixed = true
      } else {
        this.selectedBarTitleFixed = false
      }
    },
    handleScroll: function () {
      if (this.$route.name === 'ClassDetail') {
        $(window).on('scroll', this.scrollFunc)
      }
    },
    joinIn (e, g) {
      if (!this.isLogin) {
        this.goLogin()
        return
      }
      const classType = this.$route.params.classType === 'live' ? 'live' : 'nolive'
      if (this.shareJoinText === 'show') {
        this.shareJoin()
        return false
      }
      if (this.shareJoinText === 'pay') {
        // this.$router.push({ path: '/pay/' + this.infoPayNo })
        this.$router.push({ name: 'MyClass' })
        return false
      }
      if (this.shareJoinText === 'free') {
        this.subscribe(this.classData)
        return false
      }
      this.$store.commit('getjoinprice', -1)
      if (e === undefined) {
        this.activity_type = 0
      }
      if (e === 'group') {
        this.activity_type = 1
        // 发起拼团埋点
        this.zhuGeEventTrack(
          this.zhugeEvents.COURSE_DETAIL.INITIATE_A_DELEGATION_CLICK,
          [
            this.cardInfo.realPrice,
            this.cardInfo.groupPrice,
            this.groupNum,
            this.cardInfo.title,
            this.$route.params.classId,
            this.groupTop.length
          ]
        )
      }
      if (e === 'phone' && g === 'group') {
        this.activity_type = 1
      }
      if (e === 'join') {
        this.zhuGeEventTrack(this.zhugeEvents.CLICK_ENROLLMENT_BUTTON, [
          '课程详情页',
          '去参团'
        ])
      } else if (this.activity_type === 0) {
        this.zhuGeEventTrack(this.zhugeEvents.CLICK_ENROLLMENT_BUTTON, [
          '课程详情页',
          this.orginClass ? this.newBtnText : '原价报名'
        ])
      } else if (this.activity_type === 1 && e !== 'join') {
        this.zhuGeEventTrack(this.zhugeEvents.CLICK_ENROLLMENT_BUTTON, [
          '课程详情页',
          '发起拼团'
        ])
      }
      if (e === 'join') {
        this.phoneMoreSG = false
        this.activity_type = 1
        // this.$refs.JoinUpNow.showDialog(this.activity_type, g) te
        this.$refs.JoinUpNow.goConfirm(classType, this.activity_type, this.$route.params.classId, '', g)
        // 参团点击埋点
        this.zhuGeEventTrack(
          this.zhugeEvents.COURSE_DETAIL.GO_TO_DELEGATION_CLICK,
          [
            this.cardInfo.realPrice,
            this.cardInfo.groupPrice,
            this.groupNum,
            this.cardInfo.title,
            this.$route.params.classId
          ]
        )
      } else {
        this.toConfirmParams.type = classType
        this.toConfirmParams.activityType = this.activity_type
        this.toConfirmParams.classId = this.$route.params.classId
        this.handlePlayBack()
        // this.$refs.JoinUpNow.goConfirm(classType, this.activity_type, this.$route.params.classId)
      }
    },
    // 处理回放弹框
    handlePlayBack () {
      if (this.$route.params.classType !== 'offline' || this.toConfirmParams.activityType === 1) {
        this.jumpConfirmPage('')
        return
      }
      const nowTime = parseInt(new Date().getTime() / 1000)
      let realPrice = 0
      let originalPrice = 0
      let hasNoPayPlayBack = 0
      let hasNoPayClass = 0
      let isAllPlayBack = false
      let hasNoClassNum = 0
      this.classDetail.forEach((item) => {
        const judge = this.buyOfflineSubclass.indexOf(item.subclassId) === -1
        if (judge && nowTime >= item.begin_at) {
          realPrice += Number(item.price) / 100
          originalPrice += Number(item.original_price) / 100
          hasNoPayPlayBack += 1
          hasNoClassNum += 1
        } else if (judge && nowTime <= item.begin_at) {
          hasNoPayClass += 1
          hasNoClassNum += 1
        }
      })
      if (hasNoPayPlayBack === this.classDetail.length) {
        isAllPlayBack = true
      }
      const isBuyPlayback = (hasNoPayPlayBack > 0 && hasNoPayClass > 0)
      this.playBackList = [{
        title: this.cardInfo.title,
        teacher_list: this.cardInfo.teacher,
        real_price: realPrice,
        original_price: originalPrice,
        id: this.cardInfo.class_id,
        is_buyPlayback: isBuyPlayback,
        goods_id: this.cardInfo.goods_id
      }]
      if (isBuyPlayback && !isAllPlayBack) {
        this.$refs.playback.show = true
        this.$refs.playback.getReplayDiscount()
        return false
      } else if (isAllPlayBack || hasNoClassNum === hasNoPayPlayBack) {
        this.jumpConfirmPage(this.playBackList[0].goods_id)
        return false
      }
      this.jumpConfirmPage('')
      // this.$refs.JoinUpNow.goConfirm(type, activityType, classId)
    },
    // 跳转确认订单页
    jumpConfirmPage (playBackList) {
      const type = this.toConfirmParams.type
      const activityType = this.toConfirmParams.activityType
      const classId = this.toConfirmParams.classId
      if (playBackList) {
        this.$refs.JoinUpNow.goConfirm(type, activityType, classId, playBackList)
      } else {
        this.$refs.JoinUpNow.goConfirm(type, activityType, classId, '')
      }
    },
    // 参团时传入发起拼团时的原价和拼团价
    getJoinPrice (e) {
      this.$store.commit('getjoinprice', e)
      this.cardInfo.paramsPrice = e
      // console.log('参团', e)
    },
    // 获取拼团top5
    getGroupTop () {
      return api.getGroupTop({
        class_id: this.$route.params.classId,
        goods_type: 5
      })
    },
    // 直播课获取拼团接口
    getLiveGroupTop () {
      return api.getLiveGroupTop({
        class_id: this.$route.params.classId
      })
    },
    getClassDetail () {
      return api.getClassDetail({ class_id: this.$route.params.classId })
    },
    getLiveClassDetail () {
      return api.getLiveClassDetail({ class_id: this.$route.params.classId })
    },
    initOffline () {
      this.isLoadding = false
      axios.all([this.getClassDetail(), this.getGroupTop()]).then(
        axios.spread((r, group) => {
          this.isLoadding = true
          if (group.data.code === 1) {
            this.signRight2 = group.data.data
            this.groupTop = group.data.data.items
            this.groupTop1 =
              group.data.data.items.length === 0
                ? -1
                : group.data.data.items[0]
            this.groupLength = group.data.data.items.length
            this.user_group = group.data.data.user_group || {}
            if (this.user_group) {
              if (this.user_group.order_state === 1) {
                this.PayState = false // 未支付
              }
              if (this.user_group.order_state === 2) {
                this.PayState = true // 已支付
              }
              if (this.user_group.group_state < 2) {
                this.groupSuccess = false
                this.shareText = '分享完成团购'
                this.cardInfo.groupState = 1
              }
              this.orderId = this.user_group.order_no
            } else {
            }
          }
          if (r.data.code === 1) {
            const liveObj = r.data.data
            if (liveObj.union_ids && liveObj.union_ids.length > 0) {
              this.getUnionByUnionIdInfo(liveObj.union_ids)
            }
            this.isShowMaterial = r.data.data.material_goods_id > 0
            this.materialPrice = r.data.data.material_goods_price / 100
            this.shoppingCarState = r.data.data.cart_exist
            this.shoppingCarText = this.shoppingCarState ? '已加入购课单' : '加入购课单'
            const classes = r.data.data
            this.signRight = r.data.data
            const isEnded = classes.activity_info && classes.activity_info.end_at < (+new Date() / 1000)
            const hasBeginned = classes.activity_info && classes.activity_info.begin_at < (+new Date() / 1000)
            this.offlineLianbaoState = classes.activity_type === 2 && !isEnded && hasBeginned
            if (this.offlineLianbaoState) {
              this.classData.activity_info = classes.activity_info
            }
            this.classData.goods_id = Number(classes.goods_id)
            // console.log(this.signRight)
            // classes.subs_info = [{}, {}]
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.isAllPlayBackClass = nowTime >= classes.subs_info[classes.subs_info.length - 1].begin_at
            this.offlineBought = this.buyOfflineSubclass.length === classes.subs_info.length
            const classStatus =
              nowTime < classes.begin_at
                ? '未开始'
                : nowTime > classes.end_at
                  ? '已结束'
                  : '进行中'
            const subject = classes.subject_type.includes('PHY')
              ? '物'
              : classes.subject_type.includes('BIO')
                ? '生'
                : classes.subject_type.includes('CHEM')
                  ? '化'
                  : classes.subject_type.includes('MATH')
                    ? '数'
                    : classes.subject_type.includes('CHN')
                      ? '语'
                      : classes.subject_type.includes('ENG')
                        ? '英'
                        : ''
            let index = classes.subs_info.filter(
              _item => _item.begin_at < nowTime
            ).length
            index = index === -1 ? 0 : index
            // 处理周期
            const type =
              classes.time_cycle !== '' ? JSON.parse(classes.time_cycle) : ''
            const time =
              classes.cycle === '无周期'
                ? classes.cycle
                : classes.cycle +
                type
                  .map(_item => {
                    return _item.begin_at + '-' + _item.end_at
                  })
                  .join(' ')
            let groupState = classes.activity_type === 1 ? 1 : 2
            const groupNum =
              classes.activity_info === null
                ? ''
                : classes.activity_info.group_num
            const groupPrice =
              classes.activity_info === null
                ? -1
                : classes.activity_info.group_price / 100
            const groupEndTime =
              classes.activity_info === null
                ? -1
                : classes.activity_info.group_end_time
            if (classes.quota <= classes.ordered) {
              this.syPeopleSum = '课程名额已满'
            } else {
              this.syPeopleSum =
                '剩余名额：' + Number(classes.quota - classes.ordered)
            }

            if (nowTime > groupEndTime) {
              groupState = 2
              this.phonegroupState = 2
            }
            if (
              r.data.data.activity_info &&
              r.data.data.activity_info.can_open === 1
            ) {
              this.moreGroupState = true
            }
            if (
              r.data.data.activity_info &&
              r.data.data.activity_info.can_open === 0
            ) {
              this.moreGroupState = false
            }
            this.teacherArray = classes.teachers_info
            this.cardInfo = {
              id: classes.class_id,
              class_id: classes.class_id,
              goods_id: classes.goods_id,
              title: classes.title,
              subject,
              date:
                moment.unix(classes.begin_at).format('YYYY.MM.DD') +
                '-' +
                moment.unix(classes.end_at).format('YYYY.MM.DD'),
              classProcess: `已进行${index}/${classes.subs_info.length}`,
              time,
              position: classes.city,
              teacher: classes.teacher,
              price: classes.price / 100,
              desp: classes.desp,
              // 根据接口参数修改
              isFull: classes.subs_info[classes.subs_info.length - 1].begin_at > nowTime && classes.ordered >= classes.quota,
              isSignUp: classes.user_state,
              classStatus,
              classNotStart: classes.order_begin_at > nowTime,
              superUser:
                (classes.order_begin_at - nowTime) / (60 * 60 * 24) <
                classes.pre_days,
              realPrice: classes.real_price / 100,
              groupState,
              groupNum,
              groupPrice,
              groupEndTime
              // activityType: classes.activity_type,
              // activityInfo: classes.activity_info
            }
            const subclassState = classes.subs_info
            if (this.isAllPlayBackClass) {
              this.isShowCar = 1
            } else {
              this.isShowCar = subclassState[subclassState.length - 1].begin_at - 1800 < nowTime || this.syPeopleSum === '课程名额已满' ? 2 : 1
            }
            this.isFull = this.cardInfo.isFull
            this.classDetail = classes.subs_info.map((item, index) => {
              const judgePaySubclass = this.buyOfflineSubclass.indexOf(Number(item.subclass_id)) > -1
              let text
              let btnState
              // console.log('subclass', this.buyOfflineSubclass.indexOf(Number(item.subclass_id)))
              if (judgePaySubclass && nowTime > item.end_at) {
                text = '看回放'
                btnState = false
              } else if (judgePaySubclass && nowTime < item.begin_at) {
                btnState = true
                text = '线下面授'
              } else if (judgePaySubclass && nowTime >= item.begin_at && nowTime <= item.end_at) {
                btnState = true
                text = '线下面授'
              } else if (!judgePaySubclass) {
                btnState = true
                text = ''
              }
              return {
                name: item.subject || `第${item.sub_index}节小课`,
                time: moment.unix(item.begin_at).format('YYYY年MM月DD日 HH:mm'),
                teachername: item.teacher_name,
                text: text,
                subclassId: item.subclass_id,
                btnState: btnState,
                begin_at: item.begin_at,
                end_at: item.end_at,
                price: item.price,
                original_price: item.original_price
              }
            })
            this.handleSignUpButton()
            this.zhuGeEventTrack(this.zhugeEvents.COURSE_DETAIL.PAGE_LOADING, [
              this.cardInfo.isFull ? '是' : '否',
              this.cardInfo.isSignUp ? '是' : '否',
              this.cardInfo.title,
              this.cardInfo.id,
              this.cardInfo.classStatus,
              this.cardInfo.price
            ])
            // this.getMyAllCourse()
            const _this = this
            setTimeout(() => {
              const isGroup = classes.activity_info !== null && classes.activity_info.group_set === 1 &&
              (classes.activity_info.group_end_time === 0 || nowTime < classes.activity_info.group_end_time)
              _this.zhuGeEventTrack(this.zhugeEvents.VISIT_COURSE_DETAIL_PAGE, [
                classes.subject_type.indexOf('P_') > -1 ? '小学' : classes.subject_type.indexOf('J_') > -1 ? '初中' : '高中',
                filters.handleSubject(classes.subject_type),
                (classes.grade && classes.grade.split(',')) || [],
                classes.content_type === 1 ? '竞赛' : '课内',
                classes.goods_type === 2 ? '直播课' : '面授课',
                filters.handleClassType(classes.sub_type),
                classes.course_belong,
                String(classes.class_id),
                classes.title,
                classStatus,
                classes.order_begin_at > nowTime ? '未开始' : Number(classes.quota - classes.ordered) > 0 ? '报名中' : '已报满',
                Number(classes.quota - classes.ordered),
                this.lianbaoList.length > 0 ? '联报' : isGroup ? '拼团' : '无',
                Number((classes.price / 100).toFixed(2)),
                isGroup ? Number((classes.activity_info.group_price / 100).toFixed(2)) : -1
              ])
            }, 1000)
          } else {
            this.goHome()
            return false
          }
          if (this.isLogin !== '') {
            this.infoSignUp()
          }
        })
      )
    },
    liveinit () {
      this.isLoadding = false
      axios.all([this.getLiveClassDetail(), this.getLiveGroupTop()]).then(
        axios.spread((r, group) => {
          this.isLoadding = true
          if (group.data.code === 1) {
            this.signRight2 = {
              items: group.data.items,
              user_group: group.data.user_group
            }
            this.groupBuyInfo = group
            this.groupTop = group.data.items || []
            this.groupLength = group.data.items.length
            this.groupTop1 = this.groupLength === 0 ? -1 : group.data.items[0]
            if (this.groupTop1 !== -1) {
              this.groupTop1.member_info = this.groupTop1.members_info
              this.groupTop1.create_at =
                this.groupTop1.group_end_time -
                this.groupTop1.duration * 60 * 60
            }
            if (this.groupTop && this.groupTop.length) {
              this.groupTop.forEach(group => {
                group.member_info = group.members_info
                group.create_at =
                  group.group_end_time - group.duration * 60 * 60
              })
            }
            this.user_group = group.data.user_group || {}
            if (this.user_group) {
              if (this.user_group.order_state === 1) {
                this.PayState = false // 未支付
              }
              if (this.user_group.order_state === 2) {
                this.PayState = true // 已支付
              }
              if (this.user_group.group_state < 2) {
                this.groupSuccess = false
                this.shareText = '分享完成团购'
                this.cardInfo.groupState = 1
              }
              this.orderId = this.user_group.order_no
            } else {
            }
          }
          if (r.data.code === 1) {
            const liveObj = r.data.data.class_info
            if (liveObj.union_ids && liveObj.union_ids.length > 0) {
              this.getUnionByUnionIdInfo(liveObj.union_ids)
            }
            this.shoppingCarState = r.data.data.class_info.cart_exist
            this.shoppingCarText = r.data.data.class_info.cart_exist ? '已加入购课单' : '加入购课单'
            this.belong = r.data.data.class_info.course_belong
            if (
              r.data.data &&
              r.data.data.class_info &&
              !r.data.data.class_info.class_id
            ) {
              this.goHome()
              return false
            }
            const classes = r.data.data.class_info
            this.signRight = r.data.data.class_info
            this.classData = this.handleClassData(
              Object.assign({}, this.signRight)
            )
            // classes.subs_info = [{}, {}]
            const nowTime = parseInt(new Date().getTime() / 1000)
            const freeEndTime = r.data.data.class_info.subclass[r.data.data.class_info.subclass.length - 1].begin_at - 1800
            if (
              // r.data.data.class_info.type === 1003 &&
              nowTime > r.data.data.class_info.end_at
            ) {
              this.isShowBtn = false
            } else if (nowTime > freeEndTime) {
              this.isShowBtn = false
            }
            const classStatus =
              nowTime < classes.begin_at
                ? '未开始'
                : nowTime > classes.end_at
                  ? '已结束'
                  : '进行中'
            const subject = classes.subject_type.includes('PHY')
              ? '物'
              : classes.subject_type.includes('BIO')
                ? '生'
                : classes.subject_type.includes('CHEM')
                  ? '化'
                  : classes.subject_type.includes('MATH')
                    ? '数'
                    : classes.subject_type.includes('CHN')
                      ? '语'
                      : classes.subject_type.includes('ENG')
                        ? '英'
                        : ''
            let index = classes.subclass.filter(
              _item => _item.begin_at < nowTime
            ).length
            index = index === -1 ? 0 : index
            // 处理周期
            const type =
              classes.time_cycle !== '' ? JSON.parse(classes.time_cycle) : []
            const time =
              classes.cycle === '无周期'
                ? classes.cycle
                : classes.cycle +
                type
                  .map(_item => {
                    return _item.begin_at + '-' + _item.end_at
                  })
                  .join(' ')
            let groupState = classes.activity_type === 1 ? 1 : 2
            const groupNum = classes.group_num
            const groupPrice = classes.group_price / 100
            const groupEndTime = classes.group_end_time
            let virtualPrice = -1
            if (classes.virtual_price !== null) {
              virtualPrice = classes.virtual_price / 100
              // this.virtualPhonePrice = classes.virtual_price / 100
            }
            if (nowTime > groupEndTime) {
              groupState = 2
            }
            // const subclassState = classes.subclass
            this.isShowCar = classes.price / 100 > 0 ? 1 : 2
            // 判断是否团购
            if (classes.group_end_time) {
              classes.groupBuy =
                classes.group_set === 1 &&
                new Date().getTime() / 1000 - classes.group_end_time < 0
            } else {
              classes.groupBuy = classes.group_set === 1
            }
            if (classes.groupBuy) {
              this.phonegroupState = 1
            } else {
              this.phonegroupState = 2
            }
            //
            if (r.data.data.can_open === 1) {
              this.moreGroupState = true
            }
            if (r.data.data.can_open === 0) {
              this.moreGroupState = false
            }
            this.teacherArray = classes.teachers_info
            this.cardInfo = {
              id: classes.class_id,
              class_id: classes.class_id,
              goods_id: classes.goods_id,
              title: classes.subject,
              subject,
              date:
                moment.unix(classes.begin_at).format('YYYY.MM.DD') +
                '-' +
                moment.unix(classes.end_at).format('YYYY.MM.DD'),
              classProcess: `已进行${index}/${classes.subclass.length}`,
              time,
              position: classes.city,
              teacher: classes.teachers,
              price: classes.price / 100,
              virtualPrice,
              desp: classes.desp,
              // 根据接口参数修改
              isFull: classes.ordered >= classes.quota,
              isSignUp: classes.user_state,
              classStatus,
              classNotStart: classes.order_begin_at > nowTime,
              superUser:
                (classes.order_begin_at - nowTime) / (60 * 60 * 24) <
                classes.pre_days,
              realPrice: classes.price / 100,
              groupState,
              groupNum,
              groupPrice,
              groupEndTime,
              teacherArray: classes.teachers_info,
              subTitle: classes.short_desp,
              virtualPhonePrice: classes.virtual_price
            }
            if (this.classData.groupBuy) {
              this.cardInfo.paramsPrice = this.classData.group_price
            } else {
              this.cardInfo.paramsPrice = this.classData.needPrice
            }
            this.isFull = this.cardInfo.isFull
            // 遍历小课 把跳转地址 # 变成 /
            for (let i = 0; i < this.classData.subclasses.length; i++) {
              this.classData.subclasses[i].href = this.classData.subclasses[
                i
              ].href.replace(/#/, '/')
            }
            this.classDetail = this.classData.subclasses
            this.handleSignUpButton()
            this.zhuGeEventTrack(this.zhugeEvents.COURSE_DETAIL.PAGE_LOADING, [
              this.cardInfo.isFull ? '是' : '否',
              this.cardInfo.isSignUp ? '是' : '否',
              this.cardInfo.title,
              this.cardInfo.id,
              this.cardInfo.classStatus,
              this.cardInfo.price
            ])
            const _this = this
            setTimeout(() => {
              const isGroup = classes.group_set === 1 &&
              (classes.group_end_time === 0 || nowTime < classes.group_end_time)
              _this.zhuGeEventTrack(this.zhugeEvents.VISIT_COURSE_DETAIL_PAGE, [
                classes.subject_type.indexOf('P_') > -1 ? '小学' : classes.subject_type.indexOf('J_') > -1 ? '初中' : '高中',
                filters.handleSubject(classes.subject_type),
                (classes.grade && classes.grade.split(',')) || [],
                classes.content_type === 1 ? '竞赛' : '课内',
                classes.goods_type === 2 ? '直播课' : '面授课',
                filters.handleClassType(classes.type),
                classes.course_belong,
                String(classes.class_id),
                classes.subject,
                classStatus,
                '报名中',
                -1,
                this.lianbaoList.length > 0 ? '联报' : isGroup ? '拼团' : '无',
                Number((classes.price / 100).toFixed(2)),
                isGroup ? Number((classes.group_price / 100).toFixed(2)) : -1
              ])
            }, 1000)
          } else {
            this.goHome()
            return false
          }
          if (this.isLogin !== '') {
            this.infoSignUp()
          }
        })
      )
    },
    goHome () {
      this.$msgDialog('没有此课程', () => {
        this.$router.push({ path: '/' })
      })
    },
    shareCourse () {
      utils.mobShare('weixin', this.getShareParams())
      this.zhuGeEventTrack(this.zhugeEvents.COURSE_DETAIL.SHARE_CLICK, [
        this.cardInfo.title,
        this.cardInfo.id
      ])
    },
    getShareParams () {
      return {
        url: window.location.href + '?utm_source=share'
      }
    },
    back () {
      this.$router.go(-1)
    },
    infoSignUp () {
      // 按钮判断
      if (this.classState === 'live') {
        this.liveGroupHandle()
        return false
      }
      if (!this.isLogin) {
        this.btnsum = 1
        this.newBtnText = '登录后报名'
        if (
          this.signRight.activity_type === 1 &&
          this.signRight.activity_info != null &&
          this.signRight.activity_info.group_end_time * 1000 <
          new Date().getTime()
        ) {
          this.orginClass = true
          this.moreGroupState = false // 正常状态的课没有更多列表
        } else if (
          this.signRight.activity_type === 1 &&
          this.signRight.activity_info != null &&
          this.signRight.activity_info.group_end_time * 1000 >=
          new Date().getTime()
        ) {
          this.orginClass = false
          this.btnsum = 2
        } else if (
          this.signRight.activity_type === 0 &&
          this.signRight.activity_info === null
        ) {
          this.orginClass = true
          this.moreGroupState = false // 正常状态的课没有更多列表
        } else {
        }
      } else {
        this.newBtnText = '立报此课程'
        if (
          this.signRight.activity_type === 2
        ) {
          // 正常状态课
          this.orginClass = true
          this.btnsum = 1
          this.groupTop1 = -1
          this.moreGroupState = false // 正常状态的课没有更多列表
          // console.log('1')
        }
        if (
          this.signRight.activity_type === 0 &&
          this.signRight.activity_info === null
        ) {
          // 正常状态课
          this.orginClass = true
          this.btnsum = 1
          this.groupTop1 = -1
          this.moreGroupState = false // 正常状态的课没有更多列表
          // console.log('1')
        }
        if (
          this.signRight.activity_type === 1 &&
          this.signRight.activity_info != null &&
          this.signRight.activity_info.group_end_time * 1000 >=
          new Date().getTime()
        ) {
          this.orginClass = false
          this.btnsum = 2
          // console.log('2')
        }
        if (
          this.signRight.activity_type === 1 &&
          this.signRight.activity_info != null &&
          this.signRight.activity_info.group_end_time * 1000 <
          new Date().getTime()
        ) {
          this.orginClass = true
          this.btnsum = 1
          this.moreGroupState = false // 正常状态的课没有更多列表
          // console.log('3')
        }
        if (
          this.signRight2.user_group != null &&
          this.signRight2.user_group.group_state < 2 &&
          this.signRight2.user_group.order_state === 1 &&
          this.signRight.order_state !== 3
        ) {
          // console.log("待支付-发起拼团待支付/去参团待支付")   // 去支付
          // console.log('4')
          this.btnsum = 1
          this.newBtnText = '去支付'
          this.shareJoinText = 'pay'
          this.moreGroupState = false
          this.infoPayNo = this.signRight.order_no
          // console.log('这里团购', this.signRight.order_no)
        } else if (
          this.signRight2.user_group != null &&
          this.signRight2.user_group.group_state < 2 &&
          this.signRight2.user_group.order_state === 2
        ) {
          // console.log("分享团购")  // 分享
          this.btnsum = 1
          this.newBtnText = '分享完成拼团'
          this.shareJoinText = 'show'
          this.moreGroupState = false
          // console.log('5')
        } else if (
          this.signRight2.user_group != null &&
          this.signRight2.user_group.group_state === 2
        ) {
          // console.log("已支付-团购成功已支付/未成团已支付") // 已支付
          this.btnsum = 1
          this.btnClickState = true
          this.newBtnText = '已报名此课程'
          this.offlineListbtnState = true
          this.moreGroupState = false
          // console.log('6')
        } else if (this.signRight.user_state === 1 &&
          this.classDetail.length === this.buyOfflineSubclass.length) {
          // 原价购买
          // console.log("已支付-原价购买已支付")
          this.btnsum = 1
          this.btnClickState = true
          this.newBtnText = '已报名此课程'
          this.offlineListbtnState = true
          this.moreGroupState = false
          // console.log('7')
        } else if (this.signRight.order_state === 1) {
          // console.log("待支付-原价报名待支付")
          this.btnsum = 1
          this.newBtnText = '去支付'
          this.shareJoinText = 'pay'
          this.moreGroupState = false
          this.infoPayNo = this.signRight.order_no
          // console.log('8')
          // }
          //  else if (
          //   this.signRight2.user_group === null &&
          //   (this.signRight.subs_info[this.signRight.subs_info.length - 1].begin_at - 1800) * 1000 - new Date().getTime() <= 0
          // ) {
          //   // console.log("待支付-原价报名待支付")
          //   this.btnsum = 1
          //   this.btnClickState = true
          //   this.newBtnText = '课程结束'
          //   this.moreGroupState = false }
        } else if (this.classDetail.length !== this.buyOfflineSubclass.length && this.buyOfflineSubclass.length !== 0) {
          this.btnsum = 1
          this.newBtnText = '报名剩余章节'
          this.offlineListbtnState = true
          this.moreGroupState = false
        } else {
          if (this.cardInfo.classNotStart === true) {
            if (this.cardInfo.superUser) {
              this.btnClickState = false
              // this.btnsum = 1
              this.newBtnText = '提前报名'
              // console.log('11')
              if (
                this.signRight.activity_type === 1 &&
                this.signRight.activity_info != null &&
                this.signRight.activity_info.group_end_time * 1000 <
                new Date().getTime()
              ) {
                this.orginClass = true
                this.btnsum = 1
                this.moreGroupState = false // 正常状态的课没有更多列表
                // console.log('12')
              } else if (
                this.signRight.activity_type === 1 &&
                this.signRight.activity_info != null &&
                this.signRight.activity_info.group_end_time * 1000 >=
                new Date().getTime()
              ) {
                this.orginClass = false
                this.btnsum = 2
                // console.log('13')
              } else if (
                this.signRight.activity_type === 0 &&
                this.signRight.activity_info === null
              ) {
                this.orginClass = true
                this.btnsum = 1
                this.moreGroupState = false // 正常状态的课没有更多列表
                // console.log('14')
              }
              // console.log('10')
              return false
            }
            this.btnClickState = true
            this.btnsum = 1
            this.newBtnText = '报名未开始'
            return false
          }
          if (this.cardInfo.isFull === true) {
            this.btnClickState = true
            this.btnsum = 1
            this.newBtnText = '名额已满'
            // console.log('15')
            return false
          }
        }
        // else if (this.signRight2.user_group === null && (this.signRight.quota - this.signRight.ordered < this.signRight.activity_info.group_num)) {
        //   this.btnsum = 1
        //   this.btnClickState = true
        //   this.newBtnText = '剩余名额不足以开团'
        // }
        // else if (this.signRight.quota <= this.signRight.ordered) {
        //   // console.log("待支付-发起拼团待支付/去参团待支付")   // 去支付
        //   console.log('6')
        //   this.btnsum = 1
        //   this.newBtnText = '课程名额已满'
        // }
      }
    },
    liveGroupHandle () {
      if (!this.isLogin) {
        this.btnsum = 1
        this.newBtnText = '登录后报名'
        if (!this.classData.groupBuy) {
          this.orginClass = true
          this.moreGroupState = false
        } else {
          this.orginClass = false
          this.btnsum = 2
        }
      } else {
        if (this.classData.price === 0) {
          this.newBtnText = this.classData.action
          if (this.classData.isNeedBook) {
            this.btnClickState = false
            this.shareJoinText = 'free'
            this.newBtnText = this.classData.action
          }
          if (this.classData.isAllBooked) {
            this.newBtnText = '已经预约'
            this.btnClickState = this.classData.isAllBooked
          }
          this.btnsum = 1
          this.orginClass = true
          this.moreGroupState = false
        } else {
          if (this.classData.hasPurchasedAllSub) {
            this.btnsum = 1
            this.btnClickState = true
            this.newBtnText = '已报名此课程'
            this.orginClass = true
            this.moreGroupState = false
          } else if (this.classData.inShareState) {
            this.btnsum = 1
            this.newBtnText = '分享完成拼团'
            this.shareJoinText = 'show'
            this.moreGroupState = false
          } else if (Number(this.classData.online) === 0) {
            this.newBtnText = this.classData.action
            this.btnsum = 1
            this.orginClass = true
            this.moreGroupState = false
            this.btnClickState = true
          } else if (this.classData.groupBuy) {
            this.orginClass = false
            this.btnsum = 2
            this.moreGroupState = true
          } else {
            this.newBtnText = this.classData.action
            this.btnsum = 1
            this.orginClass = true
            this.moreGroupState = false
          }
        }
      }
    },
    handleSignUpButton () {
      const cardInfo = this.cardInfo
      if (!this.isLogin) {
        this.signUpBthDisabled = false
        this.signUpBthText = '登录后报名'
      } else {
        if (cardInfo.classNotStart === true) {
          if (cardInfo.superUser) {
            this.signUpBthDisabled = false
            this.signUpBthText = '提前报名'
            return false
          }
          this.signUpBthDisabled = true
          this.signUpBthText = '报名未开始'
          return false
        }
        if (cardInfo.isSignUp === 1) {
          this.signUpBthDisabled = true
          this.signUpBthText = '已报名此课程'
          return false
        }
        if (cardInfo.isFull === true) {
          this.signUpBthDisabled = true
          this.signUpBthText = '名额已满'
          return false
        }
        if (cardInfo.price === 0) {
          this.signUpBthDisabled = true
          this.signUpBthText = '立报此课程'
          return false
        }
        this.signUpBthDisabled = false
        this.signUpBthText = '立报此课程'
      }
    },
    // 查看更多的拼团
    morebuy () {
      this.$store.commit('change')
    },
    // overTime () {
    //   this.signUpBthDisabled = true
    // },
    changeMore () {
      this.phoneMoreSG = !this.phoneMoreSG
    },
    shareJoin () {
      if (this.shareJoinText === 'pay') {
        this.$router.push({ path: '/pay/' + this.infoPayNo })
      } else if (this.shareJoinText === 'free') {
        this.subscribe(this.classData)
      } else if (this.shareJoinText === 'show') {
        const memberInfo = this.user_group.member_info || []
        this.$refs.ShareTip.share(
          {
            ren: this.user_group.group_num - memberInfo.length || 0,
            originPrice: this.cardInfo.realPrice,
            groupPrice: this.user_group.group_price / 100,
            title: this.cardInfo.title,
            groupNo: this.user_group.group_id
          },
          true
        )
      }
    },
    subscribe (classData) {
      const subList = classData.subclasses
      if (
        new Date().getTime() >
        subList[subList.length - 1].begin_at * 1000 - 1000 * 60 * 30
      ) {
        this.$msgDialog('课程已开始，直接去看课？', () => {
          this.selectType('classPlan')
        })
      } else {
        this.$showDialog('确定预约该课程吗', () => {
          const ids = []
          subList.forEach(function (item) {
            if (new Date().getTime() < item.begin_at * 1000 - 1000 * 60 * 30) {
              ids.push(item.subclass_id)
            }
          })
          const dataOpt = qs.parse(window.location.search.substring(1))
          const classParams = {
            class_id: this.classData.class_id,
            grade: this.classData.grade,
            subject_type: this.classData.subject_type
          }
          const paramJson = {
            url: window.location.href,
            url_param: qs.stringify(Object.assign(dataOpt, classParams)),
            utm_source: dataOpt.utm_source || '',
            utm_campaign: dataOpt.utm_campaign || '',
            utm_medium: dataOpt.utm_medium || '',
            utm_term: dataOpt.utm_term || '',
            utm_content: dataOpt.utm_content || ''
          }
          this.booking({
            mobile: this.userInfo.mobile,
            product_id: JSON.stringify(ids),
            nocode: 1,
            is_not_landing: 1,
            param_json: JSON.stringify(paramJson)
          })
        })
      }
    },
    booking (params) {
      api.booking(params).then(res => {
        if (res.data.code === 1) {
          this.init()
          this.$message.success('预约成功，可在「我的课程」中查看')
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    groupEndCallback () {
      this.btnsum = 0
      this.newBtnText = '立报此课程'
      this.orginClass = false
      this.moreGroupState = false
      this.groupTop1 = -1
      this.shareJoinText = ''
      this.infoPayNo = 0
      this.btnClickState = false
      this.signRight = []
      this.signRight2 = []
      this.init()
    },
    collageCallback (item) {
      this.groupTop.splice(this.groupTop.indexOf(item), 1)
    },
    lianbao (e) {
      if (!this.isLogin) {
        this.goLogin()
        return
      }
      this.target = $(e.currentTarget)
      this.showLianbao = true
    },
    goLogin () {
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then(_ => {
          this.init()
        })
      })
    },
    closeLianBaoModal () {
      this.showLianbao = false
    },
    lianbaoJiesuan (data) {
      const classType = this.$route.params.classType === 'live' ? 'live' : 'nolive'
      this.$refs.JoinUpNow.goConfirm(classType, 2, this.$route.params.classId, '')
      // this.$refs.JoinUpNow.showDialog(2)
    },
    // 面授课购买小课看回放
    getMyAllCourse () {
      api
        .getMyAllCourseNew({ class_id: this.$route.params.classId, goods_type: 5 })
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data || []
            if (this.$route.params.classType === 'offline') {
              for (let i = 0; i < item.length; i++) {
                this.buyOfflineSubclass[i] = item[i].subclass_id
              }
            }
            this.initOffline()
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin,
      userInfo: state => state.user.userInfo,
      moresgstate: state => state.moresg.moresgstate
    }),
    isMobile () {
      return utils.isMobile()
    },
    qaType () {
      return this.$route.params.classType
    },
    isLianbao () {
      const cartSwitchUnion = true
      if (cartSwitchUnion === false) {
        return false
      }
      const info = this.classData ? this.classData.activity_info : null
      const hasBeginned = info && info.begin_at < (+new Date() / 1000)
      let isShowLianbao = hasBeginned
      if (!isShowLianbao) {
        isShowLianbao = this.offlineLianbaoState
      }
      return isShowLianbao
    },
    lianBaotext () {
      if (this.isLianbao && !this.shoppingCarState) {
        return '加入购课单'
      } else {
        return '已加入购课单'
      }
    },
    lianBaoDiscount () {
      if (this.isLianbao && !this.shoppingCarState) {
        return filters.lianbaoTypeText(this.classData.activity_info.discount_type, this.classData.activity_info.discount_val)
      } else {
        return ''
      }
    }
  },
  watch: {
    cardInfo: function () {
      this.handleSignUpButton()
    },
    isLogin: function () {
      if (this.isLoadding) {
        this.handleSignUpButton()
        this.infoSignUp()
      }
    },
    isLoadding: function () {
      if (this.isLoadding && this.isLogin !== '') {
        this.handleSignUpButton()
        this.infoSignUp()
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_base.scss";
.button-area {
  margin-top: 23px;
  .submit {
    width: 140px;
    height: 40px;
    border-radius: 4px;
    font-size: 20px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    letter-spacing: 7px;
  }
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.status.el-button--mini{
  padding: 4px;
  border: none;
  margin-left: 10px;
}
.disflex {
  display: flex;
}
.hand {
  cursor: pointer;
}
#class-detail-container {
  .selectedBarTitleFixed {
    position: fixed;
    top: 49px;
    z-index: 99;
    width: 804px;
  }
  .selectedBarTitleFixed-phone {
    position: fixed;
    top: 74px;
    z-index: 99;
    width: 804px;
  }
  .phone {
    display: none;
  }
  .pc-web {
    margin-top: 16px;
    display: flex;
    justify-content: center;
    .left {
      width: 71.2%;
      .web_subTitle {
        // width: 804px;
        width: 71.2%;
        box-sizing: border-box;
      }
      .title-wrap {
        padding-bottom: 25px;
        background: #fff;
        margin-bottom: 10px;
        border-radius: 2px;
      }
      .title {
        // width: 804px;
        height: 82px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        // margin-bottom: 8px;
        display: flex;
        align-items: center;
        .icon {
          margin-left: 30px;
          width: 20px;
          height: 20px;
          background: rgba(10, 201, 193, 1);
          border-radius: 11px;
          p {
            font-size: 12px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
        .detail {
          font-size: 18px;
          font-weight: 600;
          color: rgba(30, 30, 30, 1);
          margin-left: 8px;
        }
      }
      #class_teacherlist {
        width: 804px;
      }
      .content {
        // width: 804px;
        min-height: 944px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        margin-bottom: 40px;
        padding-bottom: 10px;
        // .seletct-bar {
        //   height: 46px;
        //   background: rgba(248, 249, 249, 1);
        //   display: flex;
        //   align-items: center;
        //   .select {
        //     width: 136px;
        //     height: 100%;
        //     font-size: 14px;
        //     font-weight: 400;
        //     color: rgba(44, 45, 46, 1);
        //   }
        //   .active {
        //     height: 100%;
        //     background-color: rgba(255, 255, 255, 1);
        //     border-top: 3px rgba(56, 211, 205, 1) solid;
        //   }
        // }
        // .detail-container {
        //   width: 100%;
        //   overflow: hidden;
        //   min-height: 300px;
        //   background: #fff;
          .desp {
            background: #fff;
            padding: 20px;
            img {
              max-width: 100%;
            }
          }
        // }
      }
    }
    .right {
      width: 328px;
      height: 296px;
      background: rgba(255, 255, 255, 1);
      border-radius: 2px;
      margin-left: 8px;
      border-top: 3px #00c7bf solid;
      .right-container {
        .pc-price {
          display: flex;
          span {
            background: rgba(198, 205, 218, 0.3);
            display: flex;
            align-items: center;
            margin-top: 18px;
            color: rgba(51, 51, 51, 0.5);
            font-size: 12px;
            height: 21px;
            padding: 0px 3px;
            margin-top: 27px;
            margin-left: 5px;
            border-radius: 2px;
          }
        }
        background: #fff;
        // width: 90%;
        padding: 0px 16px 34px 16px;
        // background-color: rgb(88, 88, 88,0.3);
        .info-container {
          .row {
            display: flex;
            align-items: center;
            min-height: 20px;
            margin-bottom: 6px;
            .icon {
              width: 14px;
              height: 14px;
              display: flex;
              align-items: center;
              img {
                width: 14px;
                height: 14px;
              }
            }
            .info {
              font-size: 14px;
              font-weight: 400;
              color: rgba(44, 45, 46, 1);
              margin-left: 8px;
            }
          }
          .time {
            text-align: left;
          }
        }
        .price {
          display: flex;
          font-size: 32px;
          margin-top: 18px;
          font-weight: 500;
          color: rgba(255, 160, 0, 1);
        }
        .group-time {
          font-size: 12px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 20px;
          span {
            font-size: 16px;
            font-weight: 500;
            color: rgba(239, 77, 60, 1);
            display: inline-block;
            padding: 0px 2px;
          }
        }
        .button-area {
          display: flex;
          justify-content: space-between;
          margin-top: 24px;
          .btn-share {
            width: 140px;
            height: 40px;
            border-radius: 4px;
            border: 1px solid $brand-success;
            font-size: 16px;
            font-weight: 400;
            color: $brand-success;
          }
          .btn-group {
            width: 140px;
            height: 40px;
            border-radius: 4px;
            // border: 1px solid rgba(239,77,60,1);
            font-size: 16px;
            font-weight: 400;
            // color: rgba(239,77,60,1);
            // background:rgba(255,239,238,1);
          }
          .buy {
            width: 140px;
            height: 40px;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
            width: 100%;
          }
          .groupbuy {
            width: 140px;
            height: 40px;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .lianbao-entrance{
        background: white;
        padding: 0px 16px;
        padding-bottom: 16px;
        .lianbao-top{
        background: url("~@/assets/img/lianbao/lianbao-top.png") no-repeat;
        height: 39px;
        background-size: 100% 100%;
        }
        .lianbao-list{
          padding: 18px 8px 0px 12px;
          background: rgba(51, 51, 51, 0.03);
          cursor: pointer;
          .lianbao-content{
            padding-bottom: 18px;
            border-bottom: 1px dashed rgba(51, 51, 51, 0.6);
            display: flex;
            justify-content: space-between;
            .lb-title{
              font-size: 14px;
              font-weight: 500;
              color: #273445;
            }
            .lb-discount{
              font-size: 14px;
              font-weight: 400;
              color: rgba(51, 51, 51, 0.6);
              span{
                font-size: 14px;
                font-weight: 600;
                color: #FFA50D;
              }
              span:nth-child(1){
                font-weight: 400;
                margin-right: 4px;
                color:rgba(51, 51, 51, 0.6);
              }
              i{
                position: relative;
                top: 1px;
              }
            }
          }
        }
        .lianbao-list:nth-last-child(1) .lianbao-content{
          border-bottom: 1px dashed rgba(51, 51, 51, 0);
        }
      }
      .right-bottommore {
        height: 43px;
        background: rgba(251, 251, 253, 1);
        border-radius: 0px 0px 2px 2px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(47, 48, 49, 0.48);
        text-align: right;
        line-height: 42px;
        padding-right: 14px;
        cursor: pointer;
        i {
          position: relative;
          top: 1px;
        }
      }
      .right-bottom {
        height: 50px;
        background: rgba(251, 251, 253, 1);
        display: flex;
        .buyimg {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: #dedede;
          margin-right: 6px;
          img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
        .right-bottomleft {
          padding: 16px 0px 0px 16px;
          display: flex;
          .buyname {
            line-height: 30px;
            width: 67px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .right-bottomright {
          padding: 17px 0px 0px 23px;
          display: flex;
          .right-groupinfo {
            font-size: 12px;
            font-weight: 400;
            color: rgba(47, 48, 49, 1);
            margin-right: 6px;
            span {
              color: #ef4d3c;
            }
            div:nth-child(2) {
              font-size: 12px;
              font-weight: 400;
              color: rgba(44, 45, 46, 0.78);
            }
          }
        }
      }
    }
    .isFixed {
      position: relative;
      top: 0px;
      z-index: 99;
    }
  }
  .msg-dialog {
    width: 90%;
    max-width: 420px;
  }
}
// 手机端样式处理
@media (min-width: 320px) and (max-width: 767px) {
  #class-detail-container {
    .pc-web {
      display: none;
    }
    margin: 0;
    // height: 1000px;
    .phone {
      display: block;
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .class-detail-header {
        height: 110px;
        width: 100%;
        background: white;
        border-radius: 2px;
        .back-arrow {
          width: 10px;
          height: 17px;
          padding: 14px 0 0 20px;
          img {
            height: 100%;
            width: 100%;
          }
        }
        .class-detail-title {
          text-align: left;
          margin-left: 16px;
          margin-top: 30px;
          height: 48px;
          font-size: 18px;
          font-weight: 600;
          color: black;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .phone_teacherlist {
        background: white;
        font-size: 14px;
        font-weight: 600;
        padding-left: 17px;
        margin-top: 0px;
        padding-top: 9px;
      }
      .class-detail-info {
        border-top: 6px solid rgba(237, 239, 242);
        height: auto;
        width: 100%;
        background: rgba(255, 255, 255, 1);
        .info-contaienr {
          // margin-top: 123px;
          .gap {
            height: 8px;
            background: rgba(51, 51, 51, 0.03);
            border-radius: 2px;
          }
          .sginfo {
            width: 91.4%;
            margin: auto;
            .sgtitle {
              display: flex;
              justify-content: space-between;
              div:nth-child(1) {
                font-size: 16px;
                font-weight: 500;
                color: rgba(242, 85, 85, 1);
              }
              div:nth-child(2) {
                font-size: 12px;
                font-weight: 400;
                color: rgba(51, 51, 51, 0.4);
                i {
                  position: relative;
                  top: 1px;
                }
              }
            }
            .right-bottom {
              height: 68px;
              // background:rgba(251,251,251,1);
              display: flex;
              justify-content: space-between;
              .buyimg {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background: #dedede;
                margin-right: 6px;
                img {
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                }
              }
              .right-bottomleft {
                padding: 16px 0px 0px 0px;
                display: flex;
                .buyname {
                  line-height: 30px;
                }
              }
              .right-bottomright {
                padding: 17px 0px 0px 0px;
                display: flex;
                .right-groupinfo {
                  font-size: 12px;
                  font-weight: 400;
                  color: rgba(47, 48, 49, 1);
                  margin-right: 6px;
                  span {
                    color: #ef4d3c;
                  }
                  div:nth-child(2) {
                    font-size: 12px;
                    font-weight: 400;
                    color: rgba(44, 45, 46, 0.78);
                  }
                }
              }
            }
          }
          .sub-title {
            display: flex;
            align-items: center;
            width: 100%;
            .icon {
              margin-left: 16px;
              margin-right: 6px;
              width: 8px;
              height: 8px;
              background: rgba(89, 204, 190, 1);
              border-radius: 0px 0px 4px 0px;
            }
            .info {
              width: 33.33%;
              height: 46px;
              line-height: 46px;
              text-align: center;
              background: rgba(248, 249, 249, 1);
            }
            .infocheck {
              position: relative;
              background: white;
            }
            .infocheck::before {
              position: absolute;
              left: 1px;
              height: 2px;
              width: 100%;
              content: "";
              background: #00c7bf;
            }
          }
        }
        .button-area {
          .el-button.is-disabled {
            background: #dedede;
          }
          width: 100%;
          display: flex;
          justify-content: center;
          padding-top: 90px;
          padding-bottom: 24px;
          z-index: 1;
          .join-now {
            width: 311px;
            height: 42px;
            border-radius: 23px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
        .button-area2 {
          .el-button.is-disabled {
            background: #dedede;
          }
          width: 100%;
          display: flex;
          justify-content: center;
          height: 59px;
          z-index: 1;
          .join-now {
            width: 311px;
            height: 42px;
            border-radius: 23px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .el-button--danger:nth-child(1) {
            border-color: rgba(242, 85, 85, 1);
            background: white;
            color: rgba(242, 85, 85, 1);
            height: 42px;
            border-radius: 22px 0px 0px 22px;
          }
          .el-button--danger:nth-child(2) {
            height: 42px;
            margin-left: 0px;
            border-radius: 0px 22px 22px 0px;
          }
        }
      }
      .class-lianbao-entrance{
          margin: 8px 0px;
          width: 100%;
          padding-bottom: 13px;
          background: white;
        .class-lianbao-content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 13px 16px 0px 21px;
          .class-lianbao-title{
            font-weight: 500;
            .class-lianbao-name{
              margin-left: 10px;
              display: inline-block;
              padding: 2px 8px;
              background: rgba(255, 165, 13, 0.1);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 400;
              color: #FFA50D;
            }
          }
          .class-discount{
            span{
              color: #FFA50D;
            }
            i{
              position: relative;
              top: 1px;
            }
          }
        }
      }
      .class-detail-card {
        width: 100%;
        height: 120px;
        position: relative;
        padding-bottom: 4px;
        background: rgba(255, 255, 255, 1);
        border-bottom: 1px solid rgba(51, 51, 51, 0.06);
        .iphone_process {
          // height: 18px;
          // border-radius: 1px;
          // border: 1px solid #ffa000;
          // color: #ffa000;
          // line-height: 18px;
          z-index: 1;
          position: absolute;
          right: 20px;
          top: 13px;
        }
        .syme {
          text-align: right;
          box-sizing: border-box;
          padding: 0px 25px 0px 0px;
          color: #ef4d3c;
          position: absolute;
          top: -80px;
          left: 17px;
        }
        .class-card {
          box-shadow: unset;
          -webkit-box-shadow: unset;
          width: 343px;
          height: 78px;
          border-radius: 0px;
          width: 100%;
          .subtitle {
            display: none;
          }
          .info {
            margin-top: 13px;
            .date {
              position: absolute;
              top: 2px;
              .status {
                display: none;
              }
            }
            .teacher {
              position: absolute;
              top: 95px;
              display: none;
            }
            .teacher:after {
              position: absolute;
              bottom: 0;
              left: -4px;
              right: 20px;
              height: 3px;
              width: 70px;
              content: "授课教师";
              top: -22px;
              font-size: 14px;
              color: rgba(51, 51, 51, 1);
              font-weight: 600;
            }
            .teacher-price {
              position: absolute;
              top: 29px;
            }
          }
          .infobottom {
            padding-top: 4px;
            display: flex;
            align-items: center;
            border-top: none;
            padding-top: 21px;
            position: absolute;
            top: 39px;
            right: 23px;
            justify-content: flex-end;
            .original-pricet {
              font-size: 13px;
              font-weight: 400;
              color: rgba(51, 51, 51, 0.4);
            }
            .discount-price {
              span {
                margin-right: 3px;
                font-size: 25px;
              }
            }
          }
        }
        .class-card .title {
          display: none;
        }
        .class-card .header {
          display: none;
        }
      }
    }
    .detail-container {
      .desp {
        margin: 16px 0 16px 0px;
        background: #fff;
        padding: 16px;
        img {
          max-width: 100%;
        }
      }
    }
  }
  .phoneMoreSG {
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    left: 0;
    top: 0;
    .phoneMoreSG-list {
      background: white;
      padding: 20px 0px 30px 0px;
      // height: 200px;
      position: fixed;
      bottom: 0px;
      width: 100%;
      border-radius: 8px 8px 0px 0px;
      .phoneMoreSG-title {
        display: flex;
        justify-content: space-between;
        div:nth-child(1) {
          font-size: 16px;
          font-weight: 500;
          color: rgba(242, 85, 85, 1);
        }
        i {
          position: relative;
          top: 1px;
        }
      }
      ul {
        li {
          list-style: none;
        }
      }
      .spell-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
        li {
          line-height: 32px;
          font-size: 12px;
          font-weight: 400;
          margin-top: 24px;
        }
        li:nth-child(1) {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: cadetblue;
          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
        }
        li:nth-child(2) {
          color: rgba(44, 45, 46, 1);
          width: 34px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        li:nth-child(3) {
          color: rgba(47, 48, 49, 1);
        }
        li:nth-child(4) {
          color: rgba(44, 45, 46, 0.78);
        }
        li:nth-child(5) {
          background: linear-gradient(
            90deg,
            rgba(248, 90, 74, 1) 0%,
            rgba(255, 118, 104, 1) 100%
          );
          border-radius: 4px;
          color: white;
          width: 81px;
          height: 30px;
          text-align: center;
          cursor: pointer;
        }
        .countdown {
          width: 72px;
        }
      }
    }
  }
}

.share {
  text-align: right;
  padding: 13px 14px 16px 0px;
  cursor: pointer;
  position: relative;
  img {
    width: 17px;
    height: 17px;
  }
  .syme {
    position: absolute;
    left: 12px;
    position: absolute;
    left: 16px;
    font-size: 14px;
    font-weight: 400;
    color: rgb(239, 77, 60);
  }
}
.group-info {
  display: flex;
  div {
    height: 35px;
    line-height: 35px;
  }
  div:nth-child(1) {
    font-size: 12px;
    font-weight: 500;
    color: rgba(239, 77, 60, 1);
    line-height: 38px;
    margin-right: 2px;
    span {
      background: rgba(239, 77, 60, 0.1);
      border-radius: 10px;
      padding: 0px 5px;
    }
  }
  div:nth-child(2),
  div:nth-child(3) {
    font-size: 16px;
    font-weight: 500;
    color: rgba(239, 77, 60, 1);
  }
  div:nth-child(2),
  div:nth-child(4),
  div:nth-child(5) {
    margin-right: 6px;
    p:nth-child(1) {
      font-size: 12px;
      line-height: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.5);
      background: rgba(198, 205, 218, 0.3);
      margin-bottom: 8px;
      border-radius: 2px;
    }
    p:nth-child(2) {
      font-size: 12px;
      line-height: 12px;
      font-weight: 400;
      color: rgba(51, 51, 51, 0.5);
      text-decoration: line-through;
    }
  }
  div:nth-child(3) {
    margin-right: 2px;
  }
  div:nth-child(4) {
    font-size: 26px;
    font-weight: 500;
    color: rgba(239, 77, 60, 1);
  }
  // div:nth-child(5),
  // div:nth-child(6) {
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: rgba(51, 51, 51, 0.4);
  // }
}

.btn-with-union {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  width: 100%;
  @media screen and (max-width: 767px) {
    height: 42px;
  }
  span.tag {
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 160, 0, 1);
    line-height: 12px;
    position: relative;
    margin-top: 2px;

    .left-gradient {
      position: absolute;
      left: -10px;
      top: 50%;
      transform: translateY(-1px);
      height: 1px;
      width: 8px;
      background: linear-gradient(
        90deg,
        rgba(255, 160, 0, 0) 0%,
        rgba(255, 160, 0, 1) 100%
      );
    }

    .right-gradient {
      position: absolute;
      right: -10px;
      top: 50%;
      transform: translateY(-1px);
      height: 1px;
      width: 8px;
      background: linear-gradient(
        90deg,
        rgba(255, 160, 0, 1) 0%,
        rgba(255, 160, 0, 0) 100%
      );
    }
  }
  > span {
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
